import { useEffect } from "react";
import { useTrans } from "../hooks";
import { AddressProvider } from "../apis";
import { useMap } from "react-leaflet";
import { GeoSearchControl } from "leaflet-geosearch";

export interface MapLocation {
    lat: number;
    lng: number;
    address: string;
    city: string;
    zipCode: string;
}

export interface AppGeoSearchProps {
    limit?: number;
    onSelect: (location: MapLocation) => void;
}

export const AppGeoSearch = ({ limit = 5, onSelect }: AppGeoSearchProps) => {
    const { t } = useTrans();
    const map = useMap();

    useEffect(() => {
        const provider = new AddressProvider();

        const searchControl = new (GeoSearchControl as any)({
            provider,
            showMarker: false,
            autoClose: true,
            searchLabel: t("com.AppGeoSearch:search.placeholder"),
        });

        map.addControl(searchControl);

        const onShowLocation = (result: any) => {
            const { x, y, address, city, zipCode } = result.location;
            const locationDetails: MapLocation = {
                lat: y,
                lng: x,
                address,
                city,
                zipCode,
            };
            onSelect(locationDetails);
        };

        map.on("geosearch/showlocation", onShowLocation);

        return () => {
            map.off("geosearch/showlocation", onShowLocation);
            map.removeControl(searchControl);
        };
    }, [map, onSelect, limit]);

    return null;
};
